import React, { useState } from "react";
import supabase from "../../supabaseClient/supabaseClient";
import "./FeedbackModel.css";

const FeedbackModal = ({ isOpen, onClose, template }) => {
  const [wasUseful, setWasUseful] = useState(null);
  const [wasConfusing, setWasConfusing] = useState(null);
  const [comments, setComments] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!isOpen) return null;

    const resetForm = () => {
  setWasUseful(null);
  setWasConfusing(null);
  setComments("");
};

const handleClose = () => {
  resetForm();
  onClose();
};

  const handleSubmit = async () => {
    setSubmitting(true);

    const {
      data: { user },
      error: userError,
    } = await supabase.auth.getUser();

    if (userError || !user) {
      alert("User not authenticated.");
      setSubmitting(false);
      return;
    }

    const { error } = await supabase.from("feedback").upsert({
      user_id: user.id,
      was_useful: wasUseful,
      was_confusing: wasConfusing,
      comments: comments,
      template: template,
    });

    if (error) {
      alert("Error submitting feedback.");
      console.log(error);
    } else {
      alert("Thanks for the feedback!");
      resetForm();
      onClose();
    }

    setSubmitting(false);
  };

  return (
    <div className="feedback-modal-overlay">
      <div className="feedback-modal">
        <button className="close-button-feedback-model" onClick={handleClose}>
          ✕
        </button>

        <div className="feedback-modal-inner">
          <h3>Got 30 seconds? Help us improve Worksheep!</h3>

          <div className="feedback-question">
            <p>✅ Was this worksheet useful? <span style={{color: 'red'}}>*</span></p>
            <div className="feedback-buttons-group">
              <button
                onClick={() => setWasUseful(true)}
                className={wasUseful === true ? "selected yes-selected" : ""}
              >
                Yes
              </button>
              <button
                onClick={() => setWasUseful(false)}
                className={wasUseful === false ? "selected no-selected" : ""}
              >
                No
              </button>
            </div>
          </div>

          <div className="feedback-question">
            <p>😕 Anything confusing or missing? <span style={{color: 'red'}}>*</span></p>
            <div className="feedback-buttons-group">
              <button
                onClick={() => setWasConfusing(true)}
                className={wasConfusing === true ? "selected yes-selected" : ""}
              >
                Yes
              </button>
              <button
                onClick={() => setWasConfusing(false)}
                className={wasConfusing === false ? "selected no-selected" : ""}
              >
                No
              </button>
            </div>
          </div>

          <div className="feedback-question">
            <p>💬 Quick thoughts or suggestions?</p>
            <textarea
              placeholder="Type here..."
              value={comments}
              onChange={(e) => setComments(e.target.value)}
            />
          </div>

          <div className="feedback-divider" />

          <button
            className="submit-feedback-button"
            onClick={handleSubmit}
            disabled={submitting || wasUseful === null || wasConfusing === null}
          >
            {submitting ? "Submitting..." : "Submit Feedback"}
          </button>

          <div className="google-form-cta">
            <p>
              📝 Want to share more?{" "}
              <a
                href="https://forms.gle/mFcUhdcTjCxgjykf8"
                target="_blank"
                rel="noopener noreferrer"
              >
                Fill out our Google Form
              </a>{" "}
              and get <strong>5 free credits</strong> for your first response!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;